import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Instagram } from 'lucide-react';
import { companyInfo, brands } from '../../data/mock';

const Footer = () => {
  const whatsappLink = `https://wa.me/55${companyInfo.whatsapp}?text=Olá! Gostaria de um orçamento.`;

  return (
    <footer className="bg-[#2B3990] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src={companyInfo.logo} 
              alt="Tsw Info" 
              className="h-16 w-auto mb-4 bg-white p-2 rounded"
            />
            <p className="text-gray-300 mb-4">
              Assistência técnica especializada em smartphones, tablets, notebooks e MacBooks em Osasco. Há mais de 20 anos no mesmo local.
            </p>
            <div className="space-y-2 mb-4">
              <Link to="/quem-somos" className="block text-[#8DC63F] hover:text-white transition-colors">
                Quem Somos
              </Link>
            </div>
            <a 
              href={companyInfo.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-[#8DC63F] hover:text-white transition-colors"
            >
              <Instagram size={20} />
              @{companyInfo.instagram}
            </a>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#8DC63F]">Assistência Técnica</h3>
            <ul className="space-y-2">
              {brands.map((brand) => (
                <li key={brand.id}>
                  <Link 
                    to={`/${brand.slug}`}
                    className="text-gray-300 hover:text-[#8DC63F] transition-colors"
                  >
                    Assistência {brand.name} em Osasco
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services List */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#8DC63F]">Nossos Serviços</h3>
            <ul className="space-y-2 text-gray-300">
              <li>Troca de Tela</li>
              <li>Troca de Bateria</li>
              <li>Reparo de Placa</li>
              <li>Aparelho Não Liga</li>
              <li>Contato com Água</li>
              <li>Upgrade de SSD e Memória</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#8DC63F]">Contato</h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 text-gray-300 hover:text-[#8DC63F] transition-colors"
                >
                  <Phone size={20} className="flex-shrink-0 mt-1" />
                  <span>{companyInfo.whatsappFormatted}<br /><span className="text-sm">WhatsApp</span></span>
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-center gap-3 text-gray-300 hover:text-[#8DC63F] transition-colors"
                >
                  <Mail size={20} className="flex-shrink-0" />
                  <span>{companyInfo.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-300">
                <MapPin size={20} className="flex-shrink-0 mt-1" />
                <span>{companyInfo.fullAddress}</span>
              </li>
              <li className="flex items-center gap-3 text-gray-300">
                <Clock size={20} className="flex-shrink-0" />
                <span>Seg - Sex: {companyInfo.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Tsw Info - Assistência Técnica em Osasco. Todos os direitos reservados.
            </p>
            <div className="flex gap-4 text-sm text-gray-400">
              <span>CNPJ: XX.XXX.XXX/0001-XX</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;